import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const OrdersUIContext = createContext();

export function useOrdersUIContext() {
  return useContext(OrdersUIContext);
}

export function OrdersUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async input => {
    const query = input.slice(1);
    api
      .get(`/adminPanel/orders?include=transactions,attendees,event,user&${query}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <OrdersUIContext.Provider value={value}>{children}</OrdersUIContext.Provider>;
}
